<div class="pop-up__container">
  <ng-content></ng-content>
</div>
